export default function blcktive$toHTML() {
  return this.fragment.toString(true);
}
